import '~globalstyles/styles.scss'
import 'moment/locale/sv'

import 'core-js/es6/string'
import 'core-js/modules/es6.map'
import 'core-js/es7/array'
import 'core-js/es7/object'
